import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addAlert } from "src/modules/notification/redux";
import {
  validateSnRange,
  moveSnToCompany,
  getBranchList,
} from "../../redux/action";
import {
  clearValidateResult,
  clearMoveResult,
  clearBranches,
} from "../../redux/slice";
import ManagementSnPage from "./management-sn.page";

export default function ManagementSnContainer() {
  const dispatch = useDispatch();

  const branches = useSelector((state) => state.managementSn.branches);
  const validateResult = useSelector(
    (state) => state.managementSn.validateResult
  );
  const isValidating = useSelector((state) => state.managementSn.isValidating);
  const isMoving = useSelector((state) => state.managementSn.isMoving);
  const moveResult = useSelector((state) => state.managementSn.moveResult);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [inputType, setInputType] = useState("serial_number");

  useEffect(
    () => () => {
      dispatch(clearValidateResult());
      dispatch(clearMoveResult());
      dispatch(clearBranches());
    },
    [dispatch]
  );

  useEffect(() => {
    if (moveResult && moveResult.success) {
      dispatch(
        addAlert({
          severity: "success",
          message: moveResult.message,
        })
      );
      dispatch(clearValidateResult());
      dispatch(clearMoveResult());
    } else if (moveResult && !moveResult.success) {
      dispatch(
        addAlert({
          severity: "error",
          message: moveResult.message,
        })
      );
    }
  }, [moveResult, dispatch]);

  const handleCompanyChange = useCallback(
    (company) => {
      setSelectedCompany(company);
      setSelectedBranch(null);
      dispatch(clearBranches());
      dispatch(clearValidateResult());
      if (company) {
        dispatch(getBranchList({ companyUuid: company.uuid }));
      }
    },
    [dispatch]
  );

  const handleBranchChange = useCallback((branch) => {
    setSelectedBranch(branch);
  }, []);

  const handleInputTypeChange = useCallback(
    (newInputType) => {
      setInputType(newInputType);
      dispatch(clearValidateResult());
    },
    [dispatch]
  );

  const handleValidate = useCallback(
    (fromSn, toSn) => {
      dispatch(validateSnRange({ fromSn, toSn, inputType }));
    },
    [dispatch, inputType]
  );

  const handleMove = useCallback(
    (fromSn, toSn) => {
      if (!selectedCompany || !selectedBranch) {
        dispatch(
          addAlert({
            severity: "error",
            message: "Please select a company and branch",
          })
        );
        return;
      }
      dispatch(
        moveSnToCompany({
          companyId: selectedCompany.id,
          nodeId: selectedBranch.id,
          fromSn,
          toSn,
          inputType,
        })
      );
    },
    [dispatch, selectedCompany, selectedBranch, inputType]
  );

  return (
    <ManagementSnPage
      branches={branches}
      selectedCompany={selectedCompany}
      selectedBranch={selectedBranch}
      inputType={inputType}
      validateResult={validateResult}
      isValidating={isValidating}
      isMoving={isMoving}
      onCompanyChange={handleCompanyChange}
      onBranchChange={handleBranchChange}
      onInputTypeChange={handleInputTypeChange}
      onValidate={handleValidate}
      onMove={handleMove}
    />
  );
}
